export default __webpack_public_path__ + "static/media/no.017da9e9.svg";